import axios from "axios";
export const getUrlAllPrameters = () => {
  const url = window.location.href;
  const params = new URL(url).searchParams;
  return [...params].map(param => `${param[0]}=${param[1]}`);
};

export const generateUuid = () => {
  let chars = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".split("");
  for (let i = 0, len = chars.length; i < len; i++) {
    switch (chars[i]) {
      case "x":
        chars[i] = Math.floor(Math.random() * 16).toString(16);
        break;
      case "y":
        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
        break;
    }
  }
  return chars.join("");
};

export const getUuidCookeValue = (eventUUID) => {
  const cookieValue = (document.cookie.match(
    "(^|; )" + eventUUID + "=([^;]*)"
  ) || 0)[2];

  const isPatternOk =
    /^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/.test(
      cookieValue
    );
  return { cookieValue, isPatternOk }
}

export const setCookie = (cname, cvalue, lifetimeInHours) => {
  try {
    const d = new Date();
    // cookie lifetime needs to be converted to milliseconds
    d.setTime(d.getTime() + lifetimeInHours * 60 * 60 * 1000);
    const expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  } catch (e) {
    console.log("Error cannot set the cookie");
    console.log(e);
  }
};

export const checkingTimerSleep = (s = 300) => {
  let start = Date.now();
  const timer = 5000;
  const timeoutLoop = () => {
    const millis = Date.now() - start;
    const seconds = Math.floor(millis / 1000);
    start = Date.now();

    if (seconds > s) {
      console.log(`Sleeping Duration : ${seconds}s`);
      console.log("Long Sleep!");
      window.location.reload();
    }
    setTimeout(timeoutLoop, timer);
  };
  timeoutLoop();
};

export const sendBeaconToAnalytics = (
  isTracking,
  { url: url, token: token }
) => {
  // NB The beacon is sent if the video is playing and tracking parameter is true
  if (isTracking) {
    axios({
      method: "POST",
      url: url,
      timeout: 3000,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then(res => {
        // console.log("Beacon sent");
      })
      .catch(error => {
        // console.log("Beacon not sent");
        console.log("Error: " + error);
      });
  }
};

export const sendPlayEvent = (
  isTracking,
  { url: url, token: token, uuid: uuid, eventUuid: eventUuid }
) => {
  if (isTracking) {
    axios({
      method: "POST",
      url: url,
      timeout: 3000,
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      data: {
        UUID: uuid,
        EventUUID: eventUuid,
      },
    })
      .then(res => {
        // console.log("play event sent");
      })
      .catch(error => {
        // console.log("Beacon not sent");
        console.log("Play Event Error: " + error);
      });
  }
};

export const onWindowResize = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
}

export const onEventMessage = (e, player) => {
  if (!e.data) {
    return;
  }

  let event = "";
  let value = "";
  try {
    event = JSON.parse(e.data).playerEvent;
    value = JSON.parse(e.data).playerEventValue;
  } catch (e) {
    return false;
  }

  switch (event) {
    case "mute":
      player.muted(true);
      break;
    case "unmute":
      player.muted(false);
      break;
    case "pause":
      player.pause();
      break;
    case "play":
      player.play();
      break;
    case "volume":
      // value should be 0(off) - 1.0(max), 0.5 is half way.
      player.volume(value);
      break;
    default:
      console.log("[eventMessage] The event is NOT supported.");
      break;
  }
};

export const disposeVideojs = (id) => {
  try {
    const oldPlayer = document.getElementById(id);
    if (oldPlayer) {
      videojs(oldPlayer).dispose();
    }
  } catch (e) {
    console.log(e);
  }
}